"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
class CeneoBrowserDriver {
    constructor() {
        this.name = 'CeneoBrowserDriver';
    }
    load() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.reportDebug('[Ceneo] Load');
                yield this.checkIfLoaded();
                return true;
            }
            catch (e) {
                return false;
            }
        });
    }
    reportDebug(_error) {
        if (window && typeof console !== 'undefined' && console.debug) {
            console.debug(_error);
        }
    }
    supportsEvent(event) {
        return CeneoBrowserDriver.SUPPORTED_EVENTS.includes(event.name);
    }
    track(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.reportDebug('[Ceneo] track');
            const data = event.getData();
            this.reportDebug('[Ceneo] track ' + event.name);
            switch (event.name) {
                case 'page_view':
                    return yield this.trackPageView(data);
                case 'add_payment_info':
                    return yield this.trackAddPaymentInfo(data);
                case 'add_to_cart':
                    return yield this.trackAddToCart(data);
                case 'purchase':
                    return yield this.trackPurchase(data);
                case 'view_cart':
                    return yield this.trackViewCart(data);
                case 'view_item':
                    return yield this.trackViewItem(data);
                case 'view_item_list':
                    return yield this.trackViewItemList(data);
                case 'login':
                    return yield this.trackLogin(data);
                case 'sign_up':
                    return yield this.trackSignUp(data);
                default:
                    throw new TypeError(`Event ${event.name} not supported!`);
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackPageView(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
    checkIfLoaded(timeout = 0) {
        return new Promise((resolve, reject) => {
            if (window._ceneo) {
                resolve();
            }
            else if (timeout >= CeneoBrowserDriver.AVAILABILITY_CHECK_MAX_TIMEOUT) {
                reject();
            }
            else {
                setTimeout(() => {
                    this.checkIfLoaded(timeout + CeneoBrowserDriver.AVAILABILITY_CHECK_TIMEOUT).then(() => resolve())
                        .catch(() => reject());
                }, CeneoBrowserDriver.AVAILABILITY_CHECK_TIMEOUT);
            }
        });
    }
    monetaryValue(value) {
        return Math.round((value + Number.EPSILON) * 100) / 100;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackLogin(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackSignUp(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackAddPaymentInfo(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackViewCart(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
    trackPurchase(data) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (window && window._ceneo && '_ceneo' in window) {
                window._ceneo('transaction', {
                    client_email: '',
                    order_id: data.transactionId,
                    shop_products: data.items.map(item => {
                        return {
                            id: item.id,
                            price: this.monetaryValue(item.price),
                            quantity: item.quantity,
                            currency: item.currency
                        };
                    }),
                    work_days_to_send_questionnaire: 3,
                    amount: this.monetaryValue(data.value + ((_a = data.discount) !== null && _a !== void 0 ? _a : 0))
                });
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackAddToCart(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackViewItem(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackViewItemList(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
}
exports.default = CeneoBrowserDriver;
CeneoBrowserDriver.SUPPORTED_EVENTS = [
    'page_view',
    'user_data_update',
    'subscribe',
    'unsubscribe',
    'add_payment_info',
    'add_to_cart',
    'purchase',
    'view_cart',
    'view_item',
    'view_item_list',
    'login',
    'sign_up'
];
CeneoBrowserDriver.AVAILABILITY_CHECK_TIMEOUT = 250;
CeneoBrowserDriver.AVAILABILITY_CHECK_MAX_TIMEOUT = 1500;
//# sourceMappingURL=ceneo.browser-driver.js.map